const initialProduct = {
  productPermissions: {},
  productLists: [],
  productDetails: [],
  productStatus: [],
  changedProductStatus: [],
  dashboard: [],
  loadingProduct: false,
  errorsProduct: {},
};

const productReducer = (state = initialProduct, action) => {
  switch (action.type) {
    case "GET_PRODUCTLIST_PENDING":
    case "ADD_PRODUCT_PENDING":
    case "UPDATE_PRODUCT_PENDING":
    case "UPDATE_PRODUCT_STATUS_PENDING":
    case "DELETE_PRODUCT_PENDING":
    case "GET_PRODUCTLISTBYID_PENDING":
    case "DASHBOARD_PENDING":
      return { ...state, loadingProduct: true };

    case "GET_PRODUCTLIST_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        productLists: action.payload
      };

    case "ADD_PRODUCT_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        changedProductStatus: action.payload,
      };

    case "UPDATE_PRODUCT_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        changedProductStatus: action.payload,
      };

    case "UPDATE_PRODUCT_STATUS_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        changedProductStatus: action.payload,
      };

    case "GET_PRODUCTLISTBYID_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        productDetails: action.payload?.product,
      };

    case "DELETE_PRODUCT_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        changedProductStatus: action.payload,
      };

    case "RESET_DELETE_PRODUCT_STATUS":
      return {
        ...state,
        loadingProduct: false,
        changedProductStatus: [],
        errorsProduct: {},
      };
    case "DASHBOARD_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        dashboard: action.payload?.dashboard,
      };

    case "GET_PRODUCTLIST_REJECTED":
    case "ADD_PRODUCT_REJECTED":
    case "UPDATE_PRODUCT_REJECTED":
    case "UPDATE_PRODUCT_STATUS_REJECTED":
    case "DELETE_PRODUCT_REJECTED":
    case "GET_PRODUCTLISTBYID_REJECTED":
    case "DASHBOARD_FULFILLED":
      return {
        ...state,
        loadingProduct: false,
        errorsProduct: action.payload,
      };

    default:
      return state;
  }
};

export default productReducer;
